import {
LOAD_ALL_EQUIPMENTS,LOAD_ALL_EQUIPMENTS_SUCCESS,EQUIPMENTS_API_ERROR,
INSERT_EQUIPMENTS,
INSERT_EQUIPMENTS_SUCCESS
} from "./actionTypes";

const initialState = {
  error: "",
  loading: false,
  equipments:[],
};

const equipments = (state = initialState, action) => {
  const {type,payload}=action;
  switch (type) {
    case LOAD_ALL_EQUIPMENTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case INSERT_EQUIPMENTS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case INSERT_EQUIPMENTS_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;
    case LOAD_ALL_EQUIPMENTS_SUCCESS:
      state = {
        ...state,
        loading: false,
        equipments: payload,
      };
      break;
    case EQUIPMENTS_API_ERROR:
      state = {
        ...state,
        error: payload,
        loading: false,
        message: payload,
        message_type: "Error",
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default equipments;
